import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const rows = [
  { id: 'date', label: 'Date' },
  { id: 'quantity', label: 'À préparer' },
  { id: 'quantityToSend', label: 'Préparées, à expédier' },
  { id: 'shipped', label: 'Expédiées' },
  { id: 'total', label: 'Total' },
  { id: 'export', label: 'Export' }
];

/**
 * Entête du tableau dans la section de reception
 */
const EnhancedTableHead = () => (
  <TableHead>
    <TableRow>
      {rows.map(
        row => (
          <TableCell key={row.id} align="left" style={{ fontWeight: 'bold' }}>
            {row.label}
          </TableCell>
        ),
        this
      )}
    </TableRow>
  </TableHead>
);

export default EnhancedTableHead;
